import * as React from 'react';
import {useState} from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Trans} from "react-i18next";
import TextField from "@mui/material/TextField";
import {sendPasswordResetEmail} from "firebase/auth";
import {FormHelperText} from "@mui/material";


function ForgotPassword({open, handleClose, auth}) {
    const [email, setEmail] = useState();
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const closeModal = () => {
        handleClose();
        setEmail('');
        setSuccess(false);
        setError('');
    }

    return (success ?
            <Dialog
                open={open}
                onClose={closeModal}
                PaperProps={{
                    component: 'form',
                    sx: {backgroundImage: 'none'},
                }}
            >
                <DialogTitle><Trans i18nKey={"auth.resetPass.resetPass"}/></DialogTitle>
                <DialogContent
                    sx={{display: 'flex', flexDirection: 'column', gap: 2, width: '100%'}}
                >
                    <DialogContentText>
                        <Trans i18nKey={"auth.resetPass.success"}/>
                    </DialogContentText>
                </DialogContent>
            </Dialog> :
            <Dialog
                open={open}
                onClose={closeModal}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        sendPasswordResetEmail(auth, email)
                            .then(() => {
                                setSuccess(true);
                            })
                            .catch((error) => {
                                const errorCode = error.code;
                                setError(errorCode)
                            });
                    },
                    sx: {backgroundImage: 'none'},
                }}
            >
                <DialogTitle><Trans i18nKey={"auth.resetPass.resetPass"}/></DialogTitle>
                <DialogContent
                    sx={{display: 'flex', flexDirection: 'column', gap: 2, width: '100%'}}
                >
                    <DialogContentText>
                        <Trans i18nKey={"auth.resetPass.content"}/>
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="email"
                        name="email"
                        label="Email"
                        placeholder="Email"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={event => setEmail(event.target.value)}
                    />
                </DialogContent>
                <FormHelperText error><Trans i18nKey={error.replace('/', '.errorsByCode.')}/></FormHelperText>
                <DialogActions sx={{pb: 3, px: 3}}>
                    <Button onClick={closeModal}><Trans i18nKey={"auth.resetPass.cancel"}/></Button>
                    <Button variant="contained" type="submit">
                        <Trans i18nKey={"auth.resetPass.continue"}/>
                    </Button>
                </DialogActions>
            </Dialog>

    );
}

ForgotPassword.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    auth: PropTypes.object.isRequired,
};

export default ForgotPassword;
